import { HTTP, authHeader, HTTP_FILE } from './http-service';

class ComplaintService {
  getTriage(complaintTriageId) {
    return HTTP.get(`/Complaint/triage/${encodeURIComponent(complaintTriageId)}`, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  getTriageSchemeBusinesses(complaintTriageId) {
    return HTTP.get(
      `/Complaint/triage/${encodeURIComponent(complaintTriageId)}/scheme-businesses`,
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  reviewMoreInformation(complaintTriageId, complaintTriageMoreInformationId) {
    return HTTP.post(
      `/Complaint/triage/${encodeURIComponent(complaintTriageId)}/more-information/${encodeURIComponent(complaintTriageMoreInformationId)}/review`,
      null,
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  completeTriage(complaintTriageId, completion) {
    return HTTP.post(
      `/Complaint/triage/${encodeURIComponent(complaintTriageId)}/complete`,
      completion,
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  owners() {
    return HTTP.get('/Complaint/owners', { headers: authHeader() }).then(
      (response) => response.data.model,
    );
  }

  get(reference) {
    return HTTP.get(`/Complaint/${encodeURIComponent(reference)}`, { headers: authHeader() }).then(
      (response) => response.data.model,
    );
  }

  update(reference, changes) {
    return HTTP.put(`/Complaint/${encodeURIComponent(reference)}`, changes, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  timeline(reference, scope = 'overall', workflowId = null) {
    return HTTP.get(`/Complaint/${encodeURIComponent(reference)}/timeline`, {
      headers: authHeader(),
      params: { scope, ...(workflowId ? { workflowId } : {}) },
    }).then((response) => response.data.model);
  }

  addNote(reference, note) {
    return HTTP.post(`/Complaint/${encodeURIComponent(reference)}/notes`, note, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  executeAction(reference, complaintWorkflowId, complaintActionTemplateId) {
    return HTTP.post(
      `/Complaint/${encodeURIComponent(reference)}/workflows/${encodeURIComponent(complaintWorkflowId)}/actions/${encodeURIComponent(complaintActionTemplateId)}`,
      null,
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  actionDetail(reference, complaintWorkflowId, complaintActionNotificationScheduleId) {
    return HTTP.get(
      `/Complaint/${encodeURIComponent(reference)}/workflows/${encodeURIComponent(complaintWorkflowId)}/action-notifications/${encodeURIComponent(complaintActionNotificationScheduleId)}`,
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  requestAISummary(reference) {
    return HTTP.post(`/Complaint/${encodeURIComponent(reference)}/ai/summary`, null, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  askAI(reference, prompt, complaintWorkflowIds) {
    return HTTP.post(
      `/Complaint/${encodeURIComponent(reference)}/ai/chat`,
      { prompt, complaintWorkflowIds },
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  getAIResult(reference, requestId) {
    return HTTP.get(
      `/Complaint/${encodeURIComponent(reference)}/ai/requests/${encodeURIComponent(requestId)}`,
      { headers: authHeader() },
    ).then((response) => response.data.model);
  }

  getAIHistory(reference) {
    return HTTP.get(`/Complaint/${encodeURIComponent(reference)}/ai/history`, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  clearAIChat(reference) {
    return HTTP.post(`/Complaint/${encodeURIComponent(reference)}/ai/chat/clear`, null, {
      headers: authHeader(),
    }).then((response) => response.data.model);
  }

  getSignedUrl(complaintId, filename) {
    return HTTP_FILE.get(
      `/ComplaintTimelineFile/GetPresignedPost/${complaintId}?filename=${encodeURIComponent(filename)}`,
    ).then((response) => {
      return response.data;
    });
  }

  getDownloadUrl(link) {
    return HTTP_FILE.get(`/ComplaintTimelineFile/download/${encodeURIComponent(link)}`).then(
      (response) => {
        return response.data;
      },
    );
  }

  deleteFile(link) {
    return HTTP_FILE.delete(`/ComplaintTimelineFile/${encodeURIComponent(link)}`).then(
      (response) => {
        return response.data;
      },
    );
  }
}

export default new ComplaintService();
